export default "__VITE_ASSET__CTfiE9KQ__"